import { REPORT } from '@consts/reports';
import { TotalSuccessfulCutsByMonth } from '@components/reports/dashboard/TotalSuccessfulCutsByMonth';
import { WarrantyRateByMonth } from '@components/reports/dashboard/WarrantyRateByMonth';
import { TotalSuccessfulCutsLastMonth } from '@components/reports/dashboard/TotalSuccessfulCutsLastMonth';
import { TotalSuccessfulCutsThisMonth } from '@components/reports/dashboard/TotalSuccessfulCutsThisMonth';
import { ManufacturerBreakdown } from '@components/reports/dashboard/ManufacturerBreakdown';
import { GlobalPresence } from '@components/reports/dashboard/GlobalPresence';
import { AverageCutsPerLocation } from '@components/reports/dashboard/AverageCutsPerLocation';
import { BaseReportPage } from './bases/BaseReportPage';
import { SplitReportContainer } from '@components/SplitReportContainer';
import { ReportTips } from '@components/ReportTips';
import { CutsByCategory } from '@components/reports/dashboard/CutsByCategory';
import { CutsByCategoryLocation } from '@components/reports/dashboard/CutsByCategoryLocation';

interface DashboardProps {
    showTips: boolean;
    dateRange: { startDate: string; endDate: string };
    setDateRange: (dateRange: { startDate: string; endDate: string }) => void;
}

export const Dashboard = ({ showTips, dateRange, setDateRange }: DashboardProps) => {
    return (
        <BaseReportPage setDateRange={setDateRange} dateRange={dateRange} title={'MO Insights Dashboard'}>
            {showTips && <ReportTips reportType={REPORT.DASHBOARD_TIPS} />}

            <TotalSuccessfulCutsByMonth dateRange={dateRange} />

            <SplitReportContainer
                reports={[<TotalSuccessfulCutsThisMonth key={1} />, <TotalSuccessfulCutsLastMonth key={2} />]}
            />

            <WarrantyRateByMonth dateRange={dateRange} />

            <CutsByCategoryLocation dateRange={dateRange} />

            <CutsByCategory dateRange={dateRange} />

            <ManufacturerBreakdown dateRange={dateRange} />

            <GlobalPresence dateRange={dateRange} />

            <AverageCutsPerLocation dateRange={dateRange} />
        </BaseReportPage>
    );
};
